import Header from "../../Layout/Header";

const SwiftDay = () => {
  return (
    <div>
      <Header headLine="Swift Day Messages" />
      Swift day
    </div>
  );
};

export default SwiftDay;
